import { Injectable } from '@angular/core';
import { AbstractHttpService } from '@datagrupo/dg-crud';
import { ConfigDgCrudService } from 'src/app/core/config/config-dg-crud/config-dg-crud.service';
import { environment } from 'src/environments/environment';
import { FluxoCobrancaEntity } from '../fluxo-cobranca.entity';

@Injectable({
  providedIn: 'root'
})
export class FluxoCobrancaService extends AbstractHttpService<FluxoCobrancaEntity>{

  constructor(
    public conf: ConfigDgCrudService,
  ) {
    super(conf, environment.apiUrl, 'fluxocobranca')
    this.dictionary.findOne = (val: FluxoCobrancaEntity) => {
      val.receptorVendaDTO?.map((item, index) => {
        //@ts-ignore
        val.receptorVendaDTO[index]['nome'] = item.nomeGalpao;
        //@ts-ignore
        val.receptorVendaDTO[index]['id'] = item.idGalpao;
      })
      return val;
    }

  }
}
